import { render, staticRenderFns } from "./AddUpdateActivity.vue?vue&type=template&id=2805bdfb&"
import script from "./AddUpdateActivity.vue?vue&type=script&lang=js&"
export * from "./AddUpdateActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports